import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterList, beforeList } from '../data/landing';
export function ComparisonSection() {
  return <section aria-labelledby="comparacion" className="bg-white text-stone-900" data-id="element-40" data-mp="3e7kfa4y0b8oa">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-20" data-id="element-41" data-mp="39d6eto4hmbcr">
        <div className="rounded-3xl border border-brand/30 bg-white px-6 py-14 sm:px-10 lg:px-14 lg:py-16" data-id="element-42" data-mp="34g69xgjdjen8">
          <h2 id="comparacion" className="text-center text-xs font-semibold uppercase tracking-[0.22em] text-brand" data-id="element-43" data-mp="2zgtl4q8xzxi0">
            Antes y después de organizar tu estudio
          </h2>

          <div className="mt-12 grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-44" data-mp="2qfdb4jm1hxeb">
            <article className="flex flex-col" data-id="element-45" data-mp="2qhq2fndotk41">
              <h3 className="font-serif text-2xl leading-tight text-stone-900 sm:text-3xl" data-id="element-46" data-mp="2lhtxnlx61onf">
                ¿Te pasa esto cuando estudiás contabilidad?
              </h3>
              <ul className="mt-8 space-y-5" data-id="element-47" data-mp="jpp0nw0t815u">
                {beforeList.map(item => <li key={item} className="flex gap-4" data-id="element-48" data-mp="jncmzv234cyl">
                    <XIcon className="mt-1 h-4 w-4 shrink-0 text-stone-400" aria-hidden="true" data-id="element-49" data-mp="3ae1qgi7we77u" />
                    <span className="text-base leading-relaxed text-stone-900/75" data-id="element-50" data-mp="3ehr78libzkib">{item}</span>
                  </li>)}
              </ul>
            </article>

            <article className="flex flex-col border-t border-stone-900/15 pt-10 lg:border-l lg:border-t-0 lg:pl-16 lg:pt-0" data-id="element-51" data-mp="35g06lv2ne3vb">
              <h3 className="font-serif text-2xl leading-tight text-brand sm:text-3xl" data-id="element-52" data-mp="3t5caqgj4blqr">
                Con MegaPack Contabilidad Lista
              </h3>
              <ul className="mt-8 space-y-5" data-id="element-53" data-mp="21dzfjq3xzn1">
                {afterList.map(item => <li key={item} className="flex gap-4" data-id="element-54" data-mp="3jezq6obazskm">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-55" data-mp="3oem3syv1naty" />
                    <span className="text-base leading-relaxed text-stone-900/75" data-id="element-56" data-mp="fzc8c9lnt3v5">{item}</span>
                  </li>)}
              </ul>
            </article>
          </div>
        </div>
      </div>
    </section>;
}